import { CharField, ImageField, LinkField, NumberField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Output } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"
import { FileField } from "../../components/FileField"

export default function OutputForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Output>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.title}
        onChange={(value) => {
          setFieldValue("title", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "title") : undefined}
        errorMessage={getIn(errors, "title")}
        required
      />

      <CharField
        label="Tipologia"
        layout="horizontal"
        value={values.type}
        onChange={(value) => {
          setFieldValue("type", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "type") : undefined}
        errorMessage={getIn(errors, "type")}
        required
      />
      <ImageField
        label="Immagine di anteprima"
        layout="horizontal"
        value={values.image}
        onChange={(value) => {
          setFieldValue("image", value)
        }}
      />
      <CharField
        label="Data"
        layout="horizontal"
        value={values.date}
        onChange={(value) => {
          setFieldValue("date", value)
        }}
      />
      <WysiwygField
        label="Descrizione breve"
        layout="horizontal"
        value={values.description_short}
        onChange={(value) => {
          setFieldValue("description_short", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "description_short") : undefined}
        errorMessage={getIn(errors, "description_short")}
        required
      />
      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.description}
        onChange={(value) => {
          setFieldValue("description", value)
        }}
      />
      <LinkField
        label="Link esterno"
        layout="horizontal"
        value={values.link || ""}
        onChange={(value) => {
          setFieldValue("link", value)
        }}
      />
      <FileField
        label="File allegato"
        layout="horizontal"
        value={values.attachment_file}
        onChange={(value) => {
          setFieldValue("attachment_file", value)
        }}
      />
      <NumberField
        label="Ordine"
        layout="horizontal"
        value={values.order}
        onChange={(value) => {
          setFieldValue("order", value)
        }}
      />
    </Col>
  )
}
